/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de cortes de caja.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmAdministracionCortes from "../../administracion/FrmAdministracionCortes.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmAdministracionCortesPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmAdministracionCortes">
      <FrmAdministracionCortes />
    </SizeSoftXFrmPortatil>
  );
}
